import { singleWorkstationsConstants } from '../redux-constants/singleWorkstations.constants'

export function singleWorkstationsFetch(payload) {
    return {
        type: singleWorkstationsConstants.UPDATE,
        payload,
    }
}
